module.exports = __webpack_public_path__ + "static/HowDoWeDoItEn-f135c17d82117818987b905aaf5b3cc7.png";